import api from './base-api';
import type { GetMarketsListDto, ListWithTotals } from '@sportspredict/shared';

export const marketsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		// PUBLIC
		getMarketCategories: builder.query({
			query: (categoryId: any) => ({
				url: `markets/categories?category_id=${categoryId}`,
				method: 'GET',
			}),
			extraOptions: { skipAuth: true },
		}),
		// PRIVATE
		getUserSecondChanceRank: builder.query({
			query: ({ eventId, lobbyId }: any) => ({
				url: `lobbies/second-chance/rank/${eventId}/${lobbyId}`,
				method: 'GET',
			}),
		}),
		getMarkets: builder.query<ListWithTotals<any>, GetMarketsListDto>({
			query: (body) => ({ url: 'markets/list', method: 'POST', body }),
			providesTags: (result, error, { eventId }) =>
				result
					? [
							...result.list.map((m: any) => ({ type: 'Market' as const, id: m.id })),
							{ type: 'Market' as const, id: `LIST-${eventId}` },
						]
					: [{ type: 'Market' as const, id: `LIST-${eventId}` }],
		}),
	}),
});

export default marketsApi;

export const {
	useGetMarketCategoriesQuery,
	useGetUserSecondChanceRankQuery,
	useGetMarketsQuery,
	useLazyGetMarketsQuery,
} = marketsApi;
